// Curated India states + cities reference data.
// Consumed by the TaxInvoiceModal cascading dropdowns (State → City).
// Pincode is a separate 6-digit text input (no per-state mapping —
// keeps the bundle lean; first-digit-by-state validation possible
// later if needed).
//
// State list = 28 states + 8 UTs (per Govt. of India). City list per
// state covers the major / commonly used cities; a free-text "Other"
// option in the dropdown lets users type a city not in the list so
// the form never blocks a valid address.

export const INDIA_STATES = [
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chhattisgarh",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttar Pradesh",
  "Uttarakhand",
  "West Bengal",
  // Union Territories
  "Andaman and Nicobar Islands",
  "Chandigarh",
  "Dadra and Nagar Haveli and Daman and Diu",
  "Delhi",
  "Jammu and Kashmir",
  "Ladakh",
  "Lakshadweep",
  "Puducherry",
];

export const INDIA_CITIES_BY_STATE = {
  "Andhra Pradesh": [
    "Visakhapatnam", "Vijayawada", "Guntur", "Nellore", "Kurnool",
    "Tirupati", "Rajahmundry", "Kakinada", "Anantapur", "Kadapa",
  ],
  "Arunachal Pradesh": [
    "Itanagar", "Naharlagun", "Tawang", "Pasighat", "Ziro",
  ],
  "Assam": [
    "Guwahati", "Silchar", "Dibrugarh", "Jorhat", "Nagaon",
    "Tinsukia", "Tezpur",
  ],
  "Bihar": [
    "Patna", "Gaya", "Bhagalpur", "Muzaffarpur", "Darbhanga",
    "Purnia", "Arrah", "Begusarai", "Katihar",
  ],
  "Chhattisgarh": [
    "Raipur", "Bhilai", "Bilaspur", "Korba", "Durg", "Rajnandgaon",
  ],
  "Goa": ["Panaji", "Margao", "Vasco da Gama", "Mapusa", "Ponda"],
  "Gujarat": [
    "Ahmedabad", "Surat", "Vadodara", "Rajkot", "Bhavnagar",
    "Jamnagar", "Junagadh", "Gandhinagar", "Anand", "Nadiad",
  ],
  "Haryana": [
    "Gurugram", "Faridabad", "Panipat", "Ambala", "Yamunanagar",
    "Rohtak", "Hisar", "Karnal", "Sonipat", "Panchkula", "Sirsa",
  ],
  "Himachal Pradesh": [
    "Shimla", "Mandi", "Solan", "Dharamshala", "Kullu", "Manali",
  ],
  "Jharkhand": [
    "Ranchi", "Jamshedpur", "Dhanbad", "Bokaro", "Hazaribagh",
    "Deoghar",
  ],
  "Karnataka": [
    "Bengaluru", "Mysuru", "Hubballi", "Mangaluru", "Belagavi",
    "Kalaburagi", "Davanagere", "Ballari", "Tumakuru", "Shivamogga",
  ],
  "Kerala": [
    "Thiruvananthapuram", "Kochi", "Kozhikode", "Thrissur", "Kollam",
    "Kannur", "Palakkad", "Alappuzha", "Malappuram",
  ],
  "Madhya Pradesh": [
    "Indore", "Bhopal", "Jabalpur", "Gwalior", "Ujjain", "Sagar",
    "Dewas", "Satna", "Ratlam", "Rewa",
  ],
  "Maharashtra": [
    "Mumbai", "Pune", "Nagpur", "Nashik", "Aurangabad", "Solapur",
    "Kolhapur", "Thane", "Navi Mumbai", "Amravati", "Sangli",
    "Jalgaon", "Akola", "Latur", "Dhule",
  ],
  "Manipur": ["Imphal", "Thoubal", "Bishnupur", "Churachandpur"],
  "Meghalaya": ["Shillong", "Tura", "Jowai"],
  "Mizoram": ["Aizawl", "Lunglei", "Champhai"],
  "Nagaland": ["Kohima", "Dimapur", "Mokokchung", "Tuensang"],
  "Odisha": [
    "Bhubaneswar", "Cuttack", "Rourkela", "Berhampur", "Sambalpur",
    "Puri", "Balasore",
  ],
  "Punjab": [
    "Ludhiana", "Amritsar", "Jalandhar", "Patiala", "Bathinda",
    "Mohali", "Hoshiarpur", "Pathankot",
  ],
  "Rajasthan": [
    "Jaipur", "Jodhpur", "Udaipur", "Kota", "Ajmer", "Bikaner",
    "Alwar", "Bhilwara", "Sikar", "Pali",
  ],
  "Sikkim": ["Gangtok", "Namchi", "Gyalshing"],
  "Tamil Nadu": [
    "Chennai", "Coimbatore", "Madurai", "Tiruchirappalli", "Salem",
    "Tirunelveli", "Erode", "Tiruppur", "Vellore", "Thoothukudi",
    "Dindigul", "Thanjavur",
  ],
  "Telangana": [
    "Hyderabad", "Warangal", "Nizamabad", "Karimnagar", "Khammam",
    "Mahbubnagar", "Secunderabad",
  ],
  "Tripura": ["Agartala", "Udaipur", "Dharmanagar", "Kailasahar"],
  "Uttar Pradesh": [
    "Lucknow", "Kanpur", "Ghaziabad", "Agra", "Varanasi", "Meerut",
    "Allahabad", "Bareilly", "Aligarh", "Moradabad", "Saharanpur",
    "Gorakhpur", "Noida", "Firozabad", "Jhansi", "Mathura",
  ],
  "Uttarakhand": [
    "Dehradun", "Haridwar", "Roorkee", "Haldwani", "Rudrapur",
    "Rishikesh", "Nainital",
  ],
  "West Bengal": [
    "Kolkata", "Asansol", "Siliguri", "Durgapur", "Howrah",
    "Bardhaman", "Malda", "Kharagpur",
  ],
  "Andaman and Nicobar Islands": ["Port Blair"],
  "Chandigarh": ["Chandigarh"],
  "Dadra and Nagar Haveli and Daman and Diu": ["Silvassa", "Daman", "Diu"],
  "Delhi": [
    "New Delhi", "Delhi", "Dwarka", "Rohini", "Saket", "Karol Bagh",
    "Connaught Place",
  ],
  "Jammu and Kashmir": [
    "Srinagar", "Jammu", "Anantnag", "Baramulla", "Udhampur",
  ],
  "Ladakh": ["Leh", "Kargil"],
  "Lakshadweep": ["Kavaratti"],
  "Puducherry": ["Puducherry", "Karaikal", "Yanam", "Mahe"],
};

// Convenience getter — empty array when state unknown so the FE
// doesn't crash on a typo.
export function citiesForState(state) {
  return INDIA_CITIES_BY_STATE[state] || [];
}

// Curated city → representative pincodes mapping. NOT exhaustive —
// India has ~150k pincodes which would bloat the bundle; we ship the
// 1-5 most common pincodes per major city so the dropdown is useful
// without becoming a megabyte payload. Users with a pincode not in
// this list pick the "Other (type below)" sentinel in the modal and
// type their actual pincode (still validated 6-digit at submit).
export const INDIA_PINCODES_BY_CITY = {
  // Andhra Pradesh
  "Visakhapatnam": ["530001", "530002", "530003", "530016"],
  "Vijayawada": ["520001", "520002", "520007", "520010"],
  "Guntur": ["522001", "522002", "522004"],
  "Nellore": ["524001", "524002"],
  "Kurnool": ["518001", "518002"],
  "Tirupati": ["517501", "517502"],
  "Rajahmundry": ["533101", "533102"],
  "Kakinada": ["533001", "533003"],
  // Arunachal Pradesh
  "Itanagar": ["791111", "791113"],
  "Naharlagun": ["791110"],
  // Assam
  "Guwahati": ["781001", "781005", "781011", "781028"],
  "Silchar": ["788001", "788005"],
  "Dibrugarh": ["786001", "786003"],
  "Jorhat": ["785001", "785005", "785006"],
  "Nagaon": ["782001", "782002"],
  "Tinsukia": ["786125"],
  "Tezpur": ["784001"],
  // Bihar
  "Patna": ["800001", "800013", "800020", "800026"],
  "Gaya": ["823001", "823002"],
  "Bhagalpur": ["812001", "812002"],
  "Muzaffarpur": ["842001", "842002"],
  "Darbhanga": ["846004"],
  "Purnia": ["854301"],
  // Chhattisgarh
  "Raipur": ["492001", "492007", "492013"],
  "Bhilai": ["490001", "490006"],
  "Bilaspur": ["495001"],
  "Korba": ["495677"],
  "Durg": ["491001"],
  // Goa
  "Panaji": ["403001", "403002"],
  "Margao": ["403601"],
  "Vasco da Gama": ["403802"],
  // Gujarat
  "Ahmedabad": ["380001", "380009", "380015", "380054"],
  "Surat": ["395001", "395003", "395007"],
  "Vadodara": ["390001", "390007", "390019"],
  "Rajkot": ["360001", "360002", "360005"],
  "Bhavnagar": ["364001", "364002"],
  "Jamnagar": ["361001"],
  "Gandhinagar": ["382010", "382016"],
  // Haryana
  "Gurugram": ["122001", "122002", "122018", "122051"],
  "Faridabad": ["121001", "121002", "121006"],
  "Panipat": ["132103"],
  "Ambala": ["133001"],
  "Yamunanagar": ["135001"],
  "Rohtak": ["124001"],
  "Hisar": ["125001", "125005"],
  "Karnal": ["132001"],
  "Sonipat": ["131001"],
  "Panchkula": ["134109", "134112"],
  "Sirsa": ["125055"],
  // Himachal Pradesh
  "Shimla": ["171001", "171002"],
  "Mandi": ["175001"],
  "Solan": ["173212"],
  "Dharamshala": ["176215"],
  "Kullu": ["175101"],
  "Manali": ["175131"],
  // Jharkhand
  "Ranchi": ["834001", "834002", "834008"],
  "Jamshedpur": ["831001", "831004"],
  "Dhanbad": ["826001"],
  "Bokaro": ["827001"],
  "Hazaribagh": ["825301"],
  // Karnataka
  "Bengaluru": ["560001", "560034", "560066", "560076", "560100"],
  "Mysuru": ["570001", "570011"],
  "Hubballi": ["580020"],
  "Mangaluru": ["575001", "575003"],
  "Belagavi": ["590001"],
  "Kalaburagi": ["585101"],
  // Kerala
  "Thiruvananthapuram": ["695001", "695010"],
  "Kochi": ["682001", "682011", "682024"],
  "Kozhikode": ["673001", "673004"],
  "Thrissur": ["680001"],
  "Kollam": ["691001"],
  // Madhya Pradesh
  "Indore": ["452001", "452010", "452015"],
  "Bhopal": ["462001", "462016", "462039"],
  "Jabalpur": ["482001", "482002"],
  "Gwalior": ["474001", "474002"],
  "Ujjain": ["456001"],
  // Maharashtra
  "Mumbai": ["400001", "400050", "400053", "400069", "400076"],
  "Pune": ["411001", "411014", "411037", "411057"],
  "Nagpur": ["440001", "440010", "440013"],
  "Nashik": ["422001", "422005"],
  "Aurangabad": ["431001", "431005"],
  "Solapur": ["413001"],
  "Kolhapur": ["416001"],
  "Thane": ["400601", "400607"],
  "Navi Mumbai": ["400703", "400709"],
  "Amravati": ["444601"],
  "Sangli": ["416416"],
  "Jalgaon": ["425001"],
  // Manipur
  "Imphal": ["795001", "795003"],
  // Meghalaya
  "Shillong": ["793001"],
  // Mizoram
  "Aizawl": ["796001"],
  // Nagaland
  "Kohima": ["797001"],
  "Dimapur": ["797112"],
  // Odisha
  "Bhubaneswar": ["751001", "751007", "751024"],
  "Cuttack": ["753001"],
  "Rourkela": ["769001"],
  "Berhampur": ["760001"],
  // Punjab
  "Ludhiana": ["141001", "141002", "141008"],
  "Amritsar": ["143001", "143002"],
  "Jalandhar": ["144001"],
  "Patiala": ["147001"],
  "Bathinda": ["151001"],
  "Mohali": ["160055", "160062"],
  // Rajasthan
  "Jaipur": ["302001", "302017", "302020"],
  "Jodhpur": ["342001", "342003"],
  "Udaipur": ["313001"],
  "Kota": ["324005"],
  "Ajmer": ["305001"],
  "Bikaner": ["334001"],
  // Sikkim
  "Gangtok": ["737101"],
  // Tamil Nadu
  "Chennai": ["600001", "600028", "600040", "600090"],
  "Coimbatore": ["641001", "641012", "641035"],
  "Madurai": ["625001", "625002"],
  "Tiruchirappalli": ["620001"],
  "Salem": ["636001"],
  "Tirunelveli": ["627001"],
  "Erode": ["638001"],
  "Tiruppur": ["641601"],
  // Telangana
  "Hyderabad": ["500001", "500032", "500081", "500084"],
  "Warangal": ["506002"],
  "Nizamabad": ["503001"],
  "Karimnagar": ["505001"],
  "Secunderabad": ["500003"],
  // Tripura
  "Agartala": ["799001"],
  // Uttar Pradesh
  "Lucknow": ["226001", "226010", "226024"],
  "Kanpur": ["208001", "208012", "208020"],
  "Ghaziabad": ["201001", "201009", "201014"],
  "Agra": ["282001", "282005"],
  "Varanasi": ["221001", "221005"],
  "Meerut": ["250001", "250002"],
  "Allahabad": ["211001"],
  "Bareilly": ["243001"],
  "Aligarh": ["202001"],
  "Moradabad": ["244001"],
  "Gorakhpur": ["273001"],
  "Noida": ["201301", "201305", "201310"],
  // Uttarakhand
  "Dehradun": ["248001", "248006"],
  "Haridwar": ["249401"],
  "Roorkee": ["247667"],
  "Haldwani": ["263139"],
  "Rishikesh": ["249201"],
  // West Bengal
  "Kolkata": ["700001", "700016", "700064", "700091"],
  "Asansol": ["713301"],
  "Siliguri": ["734001"],
  "Durgapur": ["713201"],
  "Howrah": ["711101"],
  // UTs
  "Port Blair": ["744101"],
  "Chandigarh": ["160001", "160017", "160022"],
  "Silvassa": ["396230"],
  "Daman": ["396210"],
  "New Delhi": ["110001", "110016", "110021", "110057"],
  "Delhi": ["110001", "110002", "110017", "110034"],
  "Dwarka": ["110075", "110078"],
  "Rohini": ["110085", "110089"],
  "Saket": ["110017"],
  "Karol Bagh": ["110005"],
  "Connaught Place": ["110001"],
  "Srinagar": ["190001", "190008"],
  "Jammu": ["180001"],
  "Leh": ["194101"],
  "Kavaratti": ["682555"],
  "Puducherry": ["605001", "605008"],
};

// Convenience getter for the modal. Empty array when city has no
// curated pincodes (e.g. user picked "Other") — the modal then
// renders the free-text fallback path.
export function pincodesForCity(city) {
  return INDIA_PINCODES_BY_CITY[city] || [];
}
